import { BucketData, ItemData } from '../../AssetBucketingResults/useAssetBucketingResults';
import { BucketDTO } from '../api/useAssetBucketingDetailsQuery';
import { getBucketChartSizesDict } from '../../AssetBucketingResults/utils/getBucketChartSizesDict';

interface Params {
  buckets: BucketDTO[];
  bucketColors: string[][];
}

export const parseBuckets = ({ buckets, bucketColors }: Params): BucketData[] => {
  const chartSizesDict = getBucketChartSizesDict(
    buckets.map(({ title, assets }) => ({
      title,
      items: assets.map(({ value }) => ({ value })),
    })),
  );

  return buckets.map((bucket, index) => {
    const colors = bucketColors[index];

    const items: ItemData[] = bucket.assets
      .sort((a, b) => b.value - a.value)
      .map((asset, i) => ({
        id: asset.id,
        name: asset.title,
        y: asset.chartValue,
        color: colors[i % colors.length],
        transactions: [],
        holdings: asset.holdings || [],
        isHoldingsBucketInheritedFromAsset: asset.isHoldingsBucketInheritedFromAsset,
        displayValue: asset.displayValue !== null ? asset.value : asset.displayValue,
        networthValue: asset.networthValue,
        excludedFromNetworth: asset.excludedFromNetworth,
        chartValue: asset.chartValue,
      }));

    return {
      ...bucket,
      total: bucket.assets.reduce((acc, asset) => acc + asset.networthValue, 0),
      chartTotal: bucket.assets.reduce((acc, asset) => acc + asset.chartValue, 0),
      data: items,
      slicedData: items,
      mainColor: colors[0],
      chartSize: chartSizesDict[bucket.title],
    };
  });
};
